import { GlobalResponseObject } from "../global-response-object";
import { SoDeadStockDetails } from "./so-dead-stock-details";

export class SoDeadStockDetailsResponse extends GlobalResponseObject {
    data?: SoDeadStockDetails[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SoDeadStockDetails[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}